import { MessageForm } from 'components/forms/Criteria';

export default MessageForm;
